import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Simple module-level cache shared across components
let cachedContent = null;
let cachedPromise = null;

function fetchContent() {
  if (cachedContent) return Promise.resolve(cachedContent);
  if (cachedPromise) return cachedPromise;
  cachedPromise = axios
    .get(`${API}/content`)
    .then((r) => {
      cachedContent = r.data || {};
      return cachedContent;
    })
    .catch(() => {
      cachedContent = {};
      return cachedContent;
    });
  return cachedPromise;
}

export function useSiteContent() {
  const [content, setContent] = useState(cachedContent || {});
  useEffect(() => {
    let alive = true;
    fetchContent().then((c) => {
      if (alive) setContent(c);
    });
    return () => {
      alive = false;
    };
  }, []);
  return content;
}

// Text override helper: returns override if non-empty, else fallback
export function txt(content, key, fallback) {
  const v = content?.[key];
  return v && v.trim() ? v : fallback;
}

// Gallery hook: fetches per section, returns null while loading, [] if empty, or items
export function useGallery(section) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/gallery/${section}`)
      .then((r) => {
        if (alive) setItems(r.data || []);
      })
      .catch(() => {
        if (alive) setItems([]);
      });
    return () => {
      alive = false;
    };
  }, [section]);
  return items;
}
